document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-mobile-toggle]');
  const drawer = document.querySelector('[data-mobile-menu]');
  if (toggle && drawer) {
    toggle.addEventListener('click', () => {
      const open = drawer.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.classList.toggle('menu-open', open);
    });
  }

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    const form = select.closest('form');
    if (!form) return;
    const price = form.closest('[data-product-section]')?.querySelector('[data-product-price]');
    select.addEventListener('change', () => {
      const opt = select.options[select.selectedIndex];
      if (price && opt.dataset.price) price.textContent = opt.dataset.price;
    });
  });
});
